import { useIntl } from '@capsicum/common';

export const useNCWSendErrorDrawer = () => {
	const { $t } = useIntl();

	return {
		intlText: {
			contactSupport: $t('ncWallet.send.error.contactSupport'),
			description: $t('ncWallet.send.error.description'),
			title: $t('ncWallet.send.error.title'),
			tryAgainButtonText: $t('ncWallet.send.error.tryAgainButtonText')
		}
	};
};
